import React, { Component } from 'react';
import __ from 'lodash';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import { Form,Row, Col, Card} from 'react-bootstrap';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import {List,ListItem,ListItemText,Collapse, Switch} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class JadwalHwForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching:false,
            isLoading: false,
            kelasParalel: [],
            jadwal: {},
            isLoadSiswa: false,
            jadwalSiswa: [],
            siswaSelected:[],
            kpSelected: [],
            kodeTa: null,
            ta: []
        }
        this.handleSubmit = this.handleSubmit.bind(this);      
        
    }
    componentWillMount() {          
        this.getKelasParalel();   
    }

    componentDidMount() {  
        document.title = ""; 
        this.fetchTa();     
        if(this.props.jadwal.idJadwal) {
            this.setState({ 
                jadwal: this.props.jadwal
            })
            this.getJadwalById(this.props.jadwal.idJadwal)
            this.getJadwalParalel();
            this.getJadwalSiswa();
        }
    }


    fetchTa = async () =>{
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function(error){
        })

        if(resTa){
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    ta: resTa.data.data
                })
            }
        }


        resTa.data.data.map((val) =>{
            if(val.status == "1"){
                this.setState({kodeTa:val.kodeTahunAjaran})
            }
        })
        
    }

    getJadwalById = async(id) => {    
        const result = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_BY_ID + id)
        .catch(function(error){ alert(error)  });
    
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){             
                this.setState({ 
                    jadwal: result.data.data                        
                });
            } 
                    
        } 
        
    }

    getKelasParalel = async() => {
        this.setState({ isLoading: true})
        const response = await accountManagement.get(CONFIG.GURU_GET_KELASPARALEL_BY_KELAS + this.props.profil.idKelas ).catch (function(error){
        })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelasParalel: response.data.data
                }) 
            }   
            this.setState({isLoading: false});            
        }
        
    }

    getJadwalParalel = async() => {
        this.setState({ isLoading: true, kpSelected: [] })
        const response = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_PARALEL + this.props.jadwal.idJadwal)
        .catch (function(error){ alert(error) })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kpSelected: response.data.data
                }) 
            }   
            this.setState({isLoading: false});            
        }
        
    }

    getJadwalSiswa = async() => {
        this.setState({ isLoading: true, siswaSelected: [] })
        const response = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_SISWA + this.props.jadwal.idJadwal)
            .catch (function(error){ alert(error) })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    siswaSelected: response.data.data
                }) 
            }   
            this.setState({isLoading: false});            
        }   
    }

    getSiswa = async(idKelasParalel, open) => {
        // this.fetchTa();
        this.setState(state => ({
            ...state,
            kelasParalel: state.kelasParalel.map(item =>
              item.idKelasParalel === idKelasParalel ? { ...item, open: !open } : { ...item, open: false }
            )
        }));

        if(!open) {
            this.setState({ isLoadSiswa: true, jadwalSiswa: []})                       

            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_KELAS_PARALEL,{
                ['idKelasParalel']: idKelasParalel,
                ['kodeTahunAjaran']: this.state.kodeTa,
            }).catch (function(error){ alert(error) })            

            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        jadwalSiswa: response.data.data
                    })    
                }   
                this.setState({isLoadSiswa: false});            
            }        
        }        
    }

    onChangeKp(e) {
        let isChecked = e.target.checked;
        let value = e.target.value;
        const { kelasParalel,kpSelected } = this.state;      
        if(isChecked) {
            kelasParalel.map( kp => {
                if (kp.idKelasParalel == value) {                    
                    this.setState(prevState => ({
                        kpSelected: [...prevState.kpSelected, kp]
                    }));
                } 
            })            
        } else {
            this.setState({ 
                kpSelected: kpSelected.filter(kp => kp.idKelasParalel != value)
            });
        } 
    }

    onChangeSiswa(e) {        
        let isChecked = e.target.checked;
        let value = e.target.value;
        
        const { jadwalSiswa,siswaSelected } = this.state;
        // do whatever you want with isChecked value         
        if(isChecked) {
            jadwalSiswa.map( siswa => {
                if (siswa.idSiswa == value) {                    
                    this.setState(prevState => ({
                        siswaSelected: [...prevState.siswaSelected, siswa]
                    }));
                }                               
            })                         
            
        } else {
            this.setState({ 
                siswaSelected: siswaSelected.filter(siswa => siswa.idSiswa != value),                
            });
        } 
        
    }

    changeJudul = (e) => { this.setState(prevState => ({ jadwal: {...prevState.jadwal, namaJadwal: e.target.value}})) }
    changeJadwalMulai = (date) => {        
        this.setState(prevState => ({     
            jadwal: {...prevState.jadwal,jadwalMulai: date}            
        }))
    }
    changeJadwalSelesai = (date) => {        
        this.setState(prevState => ({     
            jadwal: {...prevState.jadwal,jadwalSelesai: date}            
        }))
    }
    changeJadwalReport = (date) => {        
        this.setState(prevState => ({     
            jadwal: {...prevState.jadwal,jadwalReport: date}            
        }))
    }

    handleSubmit(e) {
        e.preventDefault();
        
        const formdata = new FormData(e.target)
    
        // convert FormData to json object
        // SOURCE: https://stackoverflow.com/a/46774073
        const data = {}
        formdata.forEach(function(value, prop){
            data[prop] = value
        }) 

        const dataSend = {
            ['idJadwal']: this.state.jadwal.idJadwal,
            ['idProfil']: this.props.profil.idProfilCbt,
            ['namaJadwal']: data.namaJadwal,
            ['jadwalMulai']: data.jadwalMulai,
            ['jadwalSelesai']: data.jadwalSelesai,
            ['jadwalReport']: data.jadwalReport,
            ['tahunAjaran']: this.state.jadwal.tahunAjaran,
            ['jadwalParalel']: this.state.kpSelected.map(v => v.idKelasParalel),
            ['jadwalSiswa']: this.state.siswaSelected.map(v => v.idSiswa),
            ['idSekolah']: this.props.profil.idSekolah,
            ['idKelas']: this.props.profil.idKelas,
            ['idAdmin']: this.props.profil.idAdmin,
            ['idGuru']: this.props.profil.idGuru
        }     
        
        console.log('datasend', dataSend)

        this.props.submitJadwal(dataSend)
        
    }

    handleBack() {
        this.props.handleBack(this.props.profil.idProfilCbt);
    }

    renderKpCheck(idKelasParalel) {
        let element = <Switch color="primary" value={idKelasParalel || ''} onChange={e => this.onChangeKp(e)} checked={false} /> ;
       
        this.state.kpSelected.map( item => {
            if(item.idKelasParalel === idKelasParalel) {
                element =  <Switch color="primary" value={idKelasParalel || ''} onChange={e => this.onChangeKp(e)} checked={true} />
            } 
        })        
        return element;
    }

    renderSiswaCheck(idSiswa) {
        let element = <Switch color="secondary" value={idSiswa || ''} onChange={e => this.onChangeSiswa(e)} checked={false} /> ;
       
        this.state.siswaSelected.map( item => {
            if(item.idSiswa === idSiswa) {
                element =  <Switch color="secondary" value={idSiswa || ''} onChange={e => this.onChangeSiswa(e)} checked={true} />
            } 
        })        
        return element;
    }

    render() {        
        const {jadwal, kelasParalel, jadwalSiswa} = this.state;  
        let pageTitle;        
        if(jadwal.idJadwal) {
            pageTitle = 'Edit Jadwal ' + jadwal.namaJadwal;
        } else {
            pageTitle = 'Add Jadwal ' + this.props.profil.namaProfil;
        }  
        console.log(this.state.jadwal)
        return ( 
            <>
                <Row>
                    <Col>
                        <h4>{pageTitle}</h4>
                    </Col>
                    <Col className="text-center">
                        <small>
                        Keterangan<i className="text-danger">*</i> : <br/>
                        1. Jadwal Kelas untuk menjadwalkan 1 kelas paralel.<br/>
                        2. Jadwal Siswa untuk menjadwalkan sesuai siswa yang dipilih.
                        </small>
                    </Col>
                </Row>
                
                {this.state.isLoading ? <Loader /> : 
                <Form onSubmit={this.handleSubmit}>
                    <Col sm={6}>
                        <Form.Group controlId="judul">                        
                        <Form.Label>Judul : </Form.Label>
                        <Form.Control type="text" name="namaJadwal" placeholder="Input Judul..." defaultValue={jadwal.namaJadwal} maxlength="100" required/>                        
                        </Form.Group>
                    </Col>
                    
                    <Col sm={12}>
                        <Form.Group>     
                            <Row>
                                <Col>                                    
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker   
                                        name="jadwalMulai"
                                        value={jadwal.jadwalMulai}  
                                        onChange={this.changeJadwalMulai}        
                                        label="Jadwal Mulai"
                                        onError={console.log}
                                        ampm={false}
                                        format="dd-MM-yyyy HH:mm" required
                                    />
                                    </MuiPickersUtilsProvider>
                                </Col> 
                                <Col>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker 
                                        name="jadwalSelesai"
                                        value={jadwal.jadwalSelesai}  
                                        onChange={this.changeJadwalSelesai} 
                                        label="Jadwal Selesai"
                                        onError={console.log}
                                        ampm={false}
                                        format="dd-MM-yyyy HH:mm" required
                                    />
                                    </MuiPickersUtilsProvider>
                                </Col> 

                                <Col>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker 
                                        name="jadwalReport"
                                        value={jadwal.jadwalReport}  
                                        onChange={this.changeJadwalReport}     
                                        label="Jadwal Report & Pembahasan"
                                        onError={console.log}
                                        ampm={false}
                                        minDate={jadwal.jadwalMulai}
                                        format="dd-MM-yyyy HH:mm" required
                                    />
                                    </MuiPickersUtilsProvider>
                                </Col>   
                            </Row>   
                        </Form.Group>
                    </Col>

                    <Col>
                        <Form.Group controlId="nama">                        
                        <Form.Label>Kelas Paralel : </Form.Label>
                        <List>
                        {kelasParalel.map((kp,i) => 
                        <Card style={{marginBottom:'5px'}} key={i}>
                            <Row>
                                <Col sm={6}>
                                <ListItem>       
                                    <span style={{color:'DodgerBlue'}}><i className="fa fa-folder-o" aria-hidden="true"></i></span>                             
                                    <ListItemText inset primary={kp.namaKelasParalel} />      
                                                                             
                                </ListItem>
                                </Col>

                                <Col sm={4} className="text-center" style={{margin: 'auto'}}>
                                    Jadwal Kelas: {this.renderKpCheck(kp.idKelasParalel)}
                                </Col>

                                <Col sm={2} className="text-right" style={{margin: 'auto'}}>
                                    <button type="button" className="btn btn-outline-info btn-sm" style={{marginRight:'20px'}}
                                    onClick={() => this.getSiswa(kp.idKelasParalel, kp.open)}>Jadwal Siswa</button>
                                </Col>
                            </Row>

                            {kp.open && this.state.isLoadSiswa ? <Loader /> : 
                            <Collapse timeout="auto" unmountOnExit style={{margin: '0 20px'}} in={kp.open}>
                                {jadwalSiswa.map((siswa, i) =>
                                    <Card border="info" style={{marginBottom:'5px'}} key={i}>                                        
                                            <Row>                                                
                                                <Col>
                                                    <ListItem>       
                                                        <span>{i+1}.</span>                             
                                                        <ListItemText inset primary={siswa.namaSiswa} />  
                                                    </ListItem>
                                                </Col>
                                                <Col className="text-right">
                                                    {this.renderSiswaCheck(siswa.idSiswa)}
                                                </Col>                                                           
                                            </Row> 
                                    </Card>  
                                )}
                            </Collapse>    
                            }
                        </Card>
                        )}    
                        </List>
                        </Form.Group>
                    </Col>

                    <Col>
                        <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                        <button type="submit" className="btn btn-primary pull-right">Simpan</button>
                    </Col>
                    
                </Form>
                }
                <LoaderModal isFetching={this.state.isFetching} />
            </>
         );
    }
}

export default JadwalHwForm;  